import type { VoidFunctionComponent } from 'react';

import { pluralizeIssues } from '../../../../../../shared/helpers/plural';
import Tooltip from '../../../../generic/Tooltip';
import type { ReleaseGroup } from '../../../../../../shared/projectsV2/response';

type Props = {
  releaseGroup: ReleaseGroup;
};

const ReleaseGroupIssueCounts: VoidFunctionComponent<Props> = ({ releaseGroup }) => {
  const issuesTotal = releaseGroup.scanned ? `${releaseGroup.issues} ${pluralizeIssues(releaseGroup.issues)}` : 'Unscanned';

  return (
    <div className="release-group-item__issue-counts">
      {/* This is to prevent the left padding from being overwritten. */}
      <div className="release-group-item__issue-counts__content">
        <Tooltip id="release-group-issues" tooltip={issuesTotal}>
          <div>
            <b>
              {issuesTotal}
            </b>
          </div>
        </Tooltip>
      </div>
    </div>
  );
};

export default ReleaseGroupIssueCounts;
